// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__-SZ0v","bigColWidth":"Table_bigColWidth__2ukBx","biggerColWidth":"Table_biggerColWidth__2ysaq","row":"Table_row__wSqrP","col":"Table_col__1HSY3"};